import { Link } from "react-router-dom";

import { Button } from "@/shared/foundation/primitives";
import { Goto } from "@/shared/navigation";

import styles from "./FullPageError.module.css";

export function NotFoundPage() {
  return (
    <div className={styles.container}>
      <p className={styles.heading}>404</p>
      <p className={styles.subheading}>Page Not Found</p>
      <p className={styles.description}>
        Sorry, the page you are looking for doesn&apos;t exist.
      </p>
      <div className={styles.actions}>
        <Link to={Goto.route.Home} style={{ textDecoration: "none" }}>
          <Button variant="contained" color="secondary" size="large">
            Go to Homepage
          </Button>
        </Link>
        <Button
          color="secondary"
          disabled={window.history.length <= 1}
          onClick={() => window.history.back()}
          size="large"
          variant="outlined"
        >
          Go Back
        </Button>
      </div>
    </div>
  );
}
